/* eslint-disable no-param-reassign */
import { MessageConst } from 'enums'
import MetricSeries from 'enums/MetricSeries'
import { NonNullableDataset, ResovledMetrics } from './types'

const thousandFormatter = Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

const formatValue = (val: number | undefined) => {
  if (val === undefined || val === null) return val
  return thousandFormatter.format(val)
}

// eslint-disable-next-line import/prefer-default-export
export const resolveMetrics = (data: NonNullableDataset) =>
  data.reduce<ResovledMetrics>(
    (result, metric) => {
      const { set, seriesName } = metric
      const rawValue = set?.[0]
      if (seriesName && rawValue !== null && rawValue !== undefined) {
        const value = formatValue(rawValue)
        switch (seriesName) {
          case MetricSeries.TOTAL_ENGAGEMENTS:
            result.engagements = value
            break
          case MetricSeries.TOTAL_REPOSTS:
            result.reposts = value
            break
          case MetricSeries.TOTAL_REPLIES:
            result.replies = value
            break
          case MetricSeries.LIKES:
            result.likes = value
            break
          case MetricSeries.POST_IMPRESSIONS:
          case MetricSeries.IMPRESSIONS:
            result.impressions = value
            break
          case MetricSeries.NET_SENTIMENT:
            result.netSentiment = value
            break
          case MetricSeries.POSITIVE_SENTIMENT:
            result.positiveSentiment = value
            break
          case MetricSeries.NEGATIVE_SENTIMENT:
            result.negativeSentiment = value
            break
          case MetricSeries.PASSION:
            result.passion = value
            break
          case MetricSeries.VIEWS:
            result.views = value
            break
          case MetricSeries.SCORE:
            result.score = value
            break
          default:
            break
        }
      }
      return result
    },
    {
      engagements: MessageConst.EM_DASH,
      reposts: MessageConst.EM_DASH,
      replies: MessageConst.EM_DASH,
      likes: MessageConst.EM_DASH,
      impressions: MessageConst.EM_DASH,
      netSentiment: MessageConst.EM_DASH,
      positiveSentiment: MessageConst.EM_DASH,
      negativeSentiment: MessageConst.EM_DASH,
      passion: MessageConst.EM_DASH,
      views: MessageConst.EM_DASH,
      score: MessageConst.EM_DASH
    }
  )
